import React from 'react'
import { UserDetailFormBuyerStyle } from './styled'
import { components } from 'react-select'
import makeAnimated from 'react-select/animated'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
  Spinner,
  Checkbox,
  SelectBoxCategoryUser,
  Breadcrumbs,
} from '../../components'
import ClassNames from 'classnames'
import { ICONS } from '../../themes'
import {
  ROUTE_PATH,
  redirect,
  STRING,
  textValidation,
  EMAIL_REGEX,
  Option,
  ValueContainer,
  MultiValue,
  AnimatedComponents,
  localStorageService,
} from '../../helpers'
import { usermanageController } from '../../apiService'
import { store } from 'store'
import { trimmedString } from '../../helpers/functions/strRemoveWhiteSpace'
import { toastActive } from '../../helpers/functions/toastSuccess'
import { toastFail } from '../../helpers/functions/toastFail'
import { map, filter } from 'lodash'
const dataCatOption = [
  {
    label: ' - แอสโทร',
    value: 1,
  },
  {
    label: ' - แอสโทร',
    value: 2,
  },
  {
    label: ' - แอสโทร',
    value: 3,
  },
  {
    label: ' - แอสโทร',
    value: 4,
  },
  {
    label: ' - แอสโทร',
    value: 5,
  },
  {
    label: ' - แอสโทร',
    value: 6,
  },
  {
    label: ' - แอสโทร',
    value: 7,
  },
  {
    label: ' - แอสโทร',
    value: 8,
  },
  {
    label: ' - แอสโทร',
    value: 9,
  },
  {
    label: ' - แอสโทร',
    value: 10,
  },
]
export class UserDetailFormBuyerContainer extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.state = {
      optionsRole: [
        { value: '3', label: 'Admin' },
        { value: '4', label: 'User' },
        { value: '7', label: 'Risk Management' },
      ],
      // optionsRoleValue: null,
      isEditPageState: false,
      isActive: true,
      name: '',
      email: '',
      phone: '',
      empRefId: '',
      companyId: '1',
      nameValid: false,
      emailValid: false,
      phoneValid: false,
      roleValid: false,
      empRefIdValid: false,
      formValid: true,
      disabledSubmit: false,
      isEvent: false,
      optionsRoleValue: [],
      adminRole: false,
      userRole: false,
      riskManagementRole: false,
      purchaserRole: false,
      tecRole: false,
      approverRole: false,
      observerRole: false,
      categoryCompany: [],
      valueCategoryCompany: '',
      isErrorCategoryCompany: false,
    }
    this.renderModalCreate = this.renderModalCreate.bind(this)
    this.renderUserRole = this.renderUserRole.bind(this)
    this.renderOptionsCategory = this.renderOptionsCategory.bind(this)
  }
  componentDidMount() {
    this._isMounted = true
    try {
      this.funcGetCategoryCompany()
    } catch (error) {
      console.log(error)
    }
  }
  async funcGetCategoryCompany() {
    const companyId = localStorageService.getCompanyId()
    const params = {
      companyId,
    }
    const categories = await usermanageController().getCategories(params)
    if (categories) {
      const arrCat = map(categories, (value, index) => {
        const { ID, name } = value
        return {
          value: ID,
          label: name,
        }
      })
      this.setState({ categoryCompany: arrCat })
    }
  }
  handleUserInput = e => {
    const { name, value } = e.target
    this.setState({ [name]: value }, () => {
      this.validateField(name, value.trim())
      //console.log('value!!!!!!!!!!!!!!!', value.trim())
    })
  }

  handleUserDropdown = optionsRole => {
    this.setState(
      { optionsRoleValue: optionsRole.value, roleValid: false },
      () => {
        this.validateField(optionsRole.label, optionsRole.value)
        //console.log('value!!!!!!!!!!!!!!!', optionsRole.value)
      }
    )
  }

  validateField = (fieldName, value) => {
    let nameValid = this.state.nameValid
    let emailValid = this.state.emailValid
    let phoneValid = this.state.phoneValid
    let roleValid = this.state.roleValid

    switch (fieldName) {
      case 'name':
        nameValid = value.length !== 0
        this.setState({ nameValid: nameValid })
        break
      case 'email':
        emailValid = RegExp(EMAIL_REGEX).test(value)
        //console.log('emailValid', emailValid)
        this.setState({ emailValid: emailValid })
        break
      case 'phone':
        phoneValid = value.length !== 0
        this.setState({ phoneValid: phoneValid })
        break
      case 'role':
        this.state.optionsRoleValue === null
        this.setState({ roleValid: roleValid })
        break
      default:
        break
    }

    // this.setState({
    //   nameValid: nameValid,
    //   emailValid: emailValid,
    //   phoneValid: phoneValid,
    // })
  }

  onChnageRole = (checked, roleID, roleName) => {
    if (checked) {
      this.state.optionsRoleValue.push({
        id: Number(roleID),
        name: roleName,
      })
      if (roleName === 'admin') {
        const optionsRoles = this.state.optionsRoleValue.filter(
          role => role.id === Number(roleID)
        )
        this.setState({ optionsRoleValue: optionsRoles })
      }
    } else {
      const idRole = Number(roleID)
      let index = this.state.optionsRoleValue.findIndex(x => x.id === idRole)
      this.state.optionsRoleValue.splice(index, 1)
      if (this.state.adminRole) {
        this.setState({
          userRole: false,
          riskManagementRole: false,
          purchaserRole: false,
          tecRole: false,
          approverRole: false,
          observerRole: false,
        })
      }
    }
    this.setState({})
  }

  onFormSubmit = e => {
    if (e.detail === 1) {
      e.preventDefault()
      const { role } = store.getState()
      const { valueCategoryCompany } = this.state
      this.setState({ roleValid: true })
      if (valueCategoryCompany.length === 0) {
        this.setState({ isErrorCategoryCompany: true })
      } else {
        this.setState({ isErrorCategoryCompany: false })
      }
      if (
        this.state.nameValid &&
        this.state.emailValid &&
        this.state.phoneValid &&
        this.state.optionsRoleValue.length !== 0 &&
        valueCategoryCompany.length !== 0
      ) {
        const filterCategoriesCompany = filter(valueCategoryCompany, data => {
          const { value } = data
          if (value !== 'All') {
            return data
          }
        })
        const mapCategoriesCompany = map(filterCategoriesCompany, data => {
          const { value } = data
          return {
            id: value,
          }
        })
        this.setState(
          {
            formValid: true,
            disabledSubmit: true,
          },
          () =>
            usermanageController()
              .createUser({
                full_name: trimmedString(this.state.name),
                email: trimmedString(this.state.email),
                Phone: trimmedString(this.state.phone),
                roles: this.state.optionsRoleValue,
                emp_ref_id: this.state.empRefId,
                company_id: this.state.companyId,
                categories: mapCategoriesCompany,
              })
              .then(res => {
                if (res) {
                  if (res.status === 'EmailDuplicate') {
                    toastFail('Email duplicate please change email')
                    this.setState({ disabledSubmit: false })
                  } else if (res.status === 'SendMailSuccess') {
                    toastActive('Create was successes')
                    this.props.history.push(
                      ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK
                    )
                  }
                }
              })
        )
      } else {
        this.setState({
          formValid: false,
          disabledSubmit: false,
        })
      }
    }
  }

  renderUserRole = () => {
    return (
      <Section className="form-group-control">
        <Section className="form-group-inner-wrapper checkbox">
          <Section className="checkbox-group">
            <Checkbox
              id="optionsRole_Admin"
              value="3"
              checked={this.state.adminRole}
              onChange={e => {
                this.setState({ adminRole: e.target.checked })
                this.onChnageRole(e.target.checked, e.target.value, 'admin')
              }}
            >
              Admin
            </Checkbox>
            <Checkbox
              id="optionsRole_Approver"
              value="9"
              className={this.state.adminRole ? 'is-disabled' : null}
              checked={this.state.adminRole ? false : this.state.approverRole}
              onChange={e => {
                this.setState({ approverRole: e.target.checked })
                this.onChnageRole(e.target.checked, e.target.value, 'approver')
              }}
            >
              Approver
            </Checkbox>
            <Checkbox
              id="optionsRole_Observer"
              value="11"
              className={this.state.adminRole ? 'is-disabled' : null}
              checked={this.state.adminRole ? false : this.state.observerRole}
              onChange={e => {
                this.setState({ observerRole: e.target.checked })
                this.onChnageRole(e.target.checked, e.target.value, 'observer')
              }}
            >
              Observer
            </Checkbox>
            <Checkbox
              id="optionsRole_Purchaser"
              value="8"
              className={this.state.adminRole ? 'is-disabled' : null}
              checked={this.state.adminRole ? false : this.state.purchaserRole}
              onChange={e => {
                this.setState({ purchaserRole: e.target.checked })
                this.onChnageRole(e.target.checked, e.target.value, 'purchaser')
              }}
            >
              Purchaser
            </Checkbox>
            <Checkbox
              id="optionsRole_Risk"
              value="7"
              className={this.state.adminRole ? 'is-disabled' : null}
              checked={
                this.state.adminRole ? false : this.state.riskManagementRole
              }
              onChange={e => {
                this.setState({
                  riskManagementRole: e.target.checked,
                })
                this.onChnageRole(
                  e.target.checked,
                  e.target.value,
                  'risk_management'
                )
              }}
            >
              Risk Management
            </Checkbox>
            <Checkbox
              id="optionsRole_TEC"
              value="10"
              className={this.state.adminRole ? 'is-disabled' : null}
              checked={this.state.adminRole ? false : this.state.tecRole}
              onChange={e => {
                this.setState({ tecRole: e.target.checked })
                this.onChnageRole(e.target.checked, e.target.value, 'tec')
              }}
            >
              TEC
            </Checkbox>
            <Checkbox
              id="optionsRole_User"
              value="4"
              checked={this.state.adminRole ? false : this.state.userRole}
              className={this.state.adminRole ? 'is-disabled' : null}
              onChange={e => {
                this.setState({ userRole: e.target.checked })
                this.onChnageRole(e.target.checked, e.target.value, 'user')
              }}
            >
              User
            </Checkbox>
          </Section>
        </Section>
        {this.state.optionsRoleValue.length == 0 ? (
          <Section className="message">{STRING.INVALID}</Section>
        ) : (
          <Section className="message"></Section>
        )}
      </Section>
    )
  }
  renderOptionsCategory() {
    const {
      categoryCompany,
      valueCategoryCompany,
      isErrorCategoryCompany,
    } = this.state
    const handleChange = select => {
      if (this._isMounted) {
        if (select) {
          this.setState({
            valueCategoryCompany: select,
            isErrorCategoryCompany: false,
          })
        }
      }
    }
    return (
      <Section className="form-group-control">
        <Section className="form-group-inner-wrapper">
          <SelectBoxCategoryUser
            options={categoryCompany}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option,
              MultiValue,
              ValueContainer,
              AnimatedComponents,
            }}
            allowSelectAll={true}
            onChange={handleChange}
            fieldValue={valueCategoryCompany}
            isErrCategory={isErrorCategoryCompany}
          />
        </Section>
        {isErrorCategoryCompany ? (
          <Section style={{ opacity: '1' }} className="message">
            {STRING.INVALID}
          </Section>
        ) : (
          <Section style={{ opacity: '1' }} className="message"></Section>
        )}
      </Section>
    )
  }
  renderModalCreate = (isEditPageState, isActive) => {
    return (
      <Section className="main-content form">
        <Section className="content-body">
          <Section className="form-wrapper">
            <Section className="form-group-title">Create User</Section>

            <Section
              className={
                'form-group' +
                (this.state.nameValid
                  ? ''
                  : this.state.formValid
                  ? ''
                  : ' is-error')
              }
            >
              <label>Full Name</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    id="fullname"
                    className={
                      this.state.nameValid
                        ? ''
                        : this.state.formValid
                        ? ''
                        : 'is-error'
                    }
                    type="text"
                    name="name"
                    value={this.state.name}
                    onChange={this.handleUserInput}
                  />
                </Section>

                <Section className="message">
                  {!this.state.formValid && !this.state.nameValid
                    ? STRING.INVALID
                    : ''}
                </Section>
              </Section>
            </Section>

            <Section
              className={
                'form-group' +
                (this.state.emailValid
                  ? ''
                  : this.state.formValid
                  ? ''
                  : ' is-error')
              }
            >
              <label>Email</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    id="email"
                    className={
                      this.state.emailValid
                        ? ''
                        : this.state.formValid
                        ? ''
                        : 'is-error'
                    }
                    type="text"
                    name="email"
                    value={this.state.email}
                    onChange={this.handleUserInput}
                  />
                </Section>
                {this.state.email === '' && (
                  <Section className="message">{STRING.INVALID}</Section>
                )}
                {!this.state.emailValid && this.state.email !== '' && (
                  <Section className="message">{STRING.EMAIL_INVALID}</Section>
                )}

                {this.state.emailValid && this.state.email !== '' && (
                  <Section className="message">{''}</Section>
                )}
              </Section>
            </Section>

            <Section
              className={
                'form-group' +
                (this.state.phoneValid
                  ? ''
                  : this.state.formValid
                  ? ''
                  : ' is-error')
              }
            >
              <label>Phone</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    id="phone"
                    className={
                      this.state.phoneValid
                        ? ''
                        : this.state.formValid
                        ? ''
                        : 'is-error'
                    }
                    type="text"
                    name="phone"
                    value={this.state.phone}
                    onChange={this.handleUserInput}
                  />
                </Section>

                {this.state.phone === '' && (
                  <Section className="message">{STRING.INVALID}</Section>
                )}
                {!this.state.phoneValid && this.state.phone !== '' && (
                  <Section className="message">{STRING.PHONE_INVALID}</Section>
                )}

                {this.state.phoneValid && this.state.phone !== '' && (
                  <Section className="message">{''}</Section>
                )}
              </Section>
            </Section>
            <Section className="form-row">
              <Section className="form-col col-6">
                <Section
                  className={
                    'form-group user-role' +
                    (this.state.optionsRoleValue.length == 0 &&
                    this.state.roleValid
                      ? ' is-error'
                      : '')
                  }
                >
                  <label>Role</label>
                  {this.renderUserRole()}
                </Section>
              </Section>
              <Section className="form-col col-6">
                <Section
                  className={
                    'form-group user-role' +
                    (this.state.isErrorCategoryCompany && ' is-error')
                  }
                >
                  <label>Category</label>
                  {this.renderOptionsCategory()}
                </Section>
              </Section>
            </Section>
            <Section className="form-group">
              <label>
                Employee Reference ID <br /> (Optional)
              </label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    type="text"
                    name="empRefId"
                    value={this.state.empRefId}
                    onChange={this.handleUserInput}
                  />
                </Section>
              </Section>
            </Section>

            {isEditPageState && (
              <Section className="form-group">
                <label>Active</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Switcher onChange={this.handleChange} checked={isActive} />
                  </Section>

                  <Section className="message"></Section>
                </Section>
              </Section>
            )}
          </Section>

          <Section
            className={
              'loading' + (this.state.disabledSubmit ? ' show' : ' none')
            }
          >
            <Spinner />
          </Section>
          <Section className="form-actions">
            <Button
              className="theme-border-gray"
              onClick={() => {
                this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK)
              }}
            >
              Cancel
            </Button>

            <Button
              className="theme-green"
              disabled={this.state.disabledSubmit}
              onClick={this.onFormSubmit}
            >
              Save
            </Button>
          </Section>
        </Section>
      </Section>
    )
  }

  render() {
    const { optionsRole, isEditPageState, isActive, isEvent } = this.state
    const { role } = store.getState()

    return (
      <React.Fragment>
        <UserDetailFormBuyerStyle>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_user_form"
                  src={ICONS['icon-user-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_user_form" className="title">
                  User Management
                </Section>
                <Breadcrumbs props={this.props} />
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          {this.renderModalCreate(isEditPageState, isActive)}
        </UserDetailFormBuyerStyle>
      </React.Fragment>
    )
  }
}
